import React, { FC, useState, useCallback } from 'react';
import { InputProps } from './types';
import { Input as ChakraInput } from '@chakra-ui/react';
import { withInputAddons } from './hoc';
import { FieldTypes } from '../../';

const InputWithElements = withInputAddons('Input')(ChakraInput) as FC<InputProps>;

export const Input: FC<InputProps> = ({ type, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = useCallback(() => setShowPassword(!showPassword), [showPassword]);

  return (
    <InputWithElements
      data-object-type="input"
      type={type === FieldTypes.password && showPassword ? FieldTypes.text : type}
      {...props}
      toggleShowPassword={type === FieldTypes.password ? toggleShowPassword : undefined}
      showPassword={type === FieldTypes.password ? showPassword : undefined}
      sx={{
        '::-webkit-search-cancel-button': {
          display: 'none',
        },
      }}
    />
  );
};
